<app-backdrop
  [isVisible]="languagePopupService.isOpen$ | async"
  (closed)="close()"
  overflowStyleOverwrite="scroll"
  *transloco="let t"
>
  <div class="popup-container" [class.is-slide-in]="!languagePopupService.isPopup">
    <div class="popup-content">
      <svg-icon class="popup-logo" key="logo" fontSize="71px"></svg-icon>

      <div class="popup-header">
        {{ t('Choose language version') }}
        <button
          app-button="icon-button"
          class="close-button"
          [attr.aria-label]="t('Close menu')"
          (click)="close()"
        >
          <svg-icon key="close" size="sm"></svg-icon>
        </button>
      </div>

      <div class="popup-subtext">
        <svg-icon key="info" size="md" class="info-icon"></svg-icon>
        {{
          t(
            'Changing the language version of the store may affect supported currencies and availability offers and delivery options.'
          )
        }}
      </div>

      <div class="popup-locale">
        <label [for]="localeLabelFor" class="visually-hidden">
          {{ t('Choose language version') }}
        </label>
        <ng-select
          [labelForId]="localeLabelFor"
          [searchable]="false"
          [clearable]="false"
          [hideSelected]="true"
          [formControl]="localeControl"
        >
          @for (option of availableLocales; track option.locale) {
            <ng-option [value]="option.locale">
              <div class="option-container">
                <img
                  ngSrc="assets/svg/{{ option.locale }}.svg"
                  alt=""
                  width="18"
                  height="14"
                />
                {{ option.localeData.languageName }} ({{ option.localeData.currency }})
              </div>
            </ng-option>
          }
        </ng-select>
      </div>

      <div class="popup-actions">
        <button app-button (click)="saveLocale()">
          {{ t('Apply') }}
        </button>
        <button app-button="primary-stroked" class="cancel-button" (click)="close()">
          {{ t('Cancel') }}
        </button>
      </div>
    </div>
    <div class="popup-frame"></div>
  </div>
</app-backdrop>
